import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import ProductTable from '../../components/ProductTable/ProductTable';
import './Product.scss';

const Product = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateProduct = () => {
    navigate('/products/create');
  };

  return (
    <div className="product-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('products')}</div>
        <ProductTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-product-fab"
        onClick={handleCreateProduct}
        title={t('createProduct')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default Product; 